import { excerptPipe } from './excerpt.pipe';
import { NgModule } from '@angular/core';
import { CardMaskPipe } from './char-mask.pipe';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './safe-html.pipe';

@NgModule({
  declarations: [
    CardMaskPipe,
    excerptPipe,
    SafeHtmlPipe
  ],
  imports: [CommonModule],
  exports: [
    CardMaskPipe,
    excerptPipe,
    SafeHtmlPipe
  ]
})
export class PipesModule { }
